import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { SITE } from "../../lib/data";

const CtaBand = ({
  title = "Let's talk about your next project.",
  subtitle = "Repairs, renovations, preventive maintenance or urgent facility issues — contact Petroline Services to discuss your requirements.",
}) => (
  <section data-testid="cta-band" className="relative overflow-hidden bg-ember">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-10 top-1/2 -translate-y-1/2 select-none font-display text-[22vw] font-extrabold leading-none text-black/10"
    >
      P
    </div>
    <div className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
      <Reveal>
        <h2 className="max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-coal sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-coal/70 md:text-lg">{subtitle}</p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/contact"
            data-testid="cta-band-request-btn"
            className="group inline-flex items-center justify-center gap-3 bg-coal px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-white transition-transform duration-200 hover:-translate-y-0.5"
          >
            Request Service
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
          <a
            href={SITE.phoneHref}
            data-testid="cta-band-call-btn"
            className="inline-flex items-center justify-center gap-3 border-2 border-coal px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-coal transition-colors duration-200 hover:bg-coal hover:text-white"
          >
            <Phone className="h-4 w-4" />
            Call {SITE.phone}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
